import React from 'react';
import { Outlet } from 'react-router-dom';
import HeaderSection from './Header/HeaderSection';

const Layout = () => {
  return (
    <>
      <HeaderSection />
      <Outlet />
    </>
  );
};

export default Layout;
